import { render } from 'react-dom';
import { __ } from '@wordpress/i18n';

import './admin.scss';

document.addEventListener('DOMContentLoaded', () => {
	const adminEl = document.querySelector('.bphpAdminHelpPage');

	const features = [
		{
			title: 'Need any Assistance?',
			description: 'Our Expert Support Team is always ready to help you out promptly.',
			iconClass: 'fa fa-life-ring',
			link: 'https://bplugins.com/support',
			linkText: 'Contact Support'
		},
		{
			title: 'Looking for Documentation?',
			description: 'We have detailed documentation on every aspects of the plugin.',
			iconClass: 'fa fa-file-text',
			link: 'https://wordpress.org/plugins/header-promo/#description',
			linkText: 'Documentation'
		},
		{
			title: 'Liked This Plugin?',
			description: 'Glad to know that, you can support us by leaving a 5 &#11088; rating.',
			iconClass: 'fa fa-thumbs-up',
			link: 'https://wordpress.org/support/plugin/header-promo/reviews/#new-post',
			linkText: 'Rate the Plugin'
		}
	];

	render(<div className='bplContainer'>
		<div className='header box'>
			<img src='https://ps.w.org/header-promo/assets/icon-128x128.png' alt='Header Promo Logo' />

			<div>
				<h1>{__('Thanks for Installing Header Promo Plugin.', 'header-promo')}</h1>
				<p>{__('Please follow the links below to get some helpful resources.', 'header-promo')}</p>
			</div>
		</div>

		<div className='body'>
			<div className='features col-3 col-tab-2 col-mob-1'>
				{features.map(feature => {
					const { title, description, iconClass, link, linkText } = feature;

					return <div className='feature box'>
						<i className={iconClass}></i>
						<h3 dangerouslySetInnerHTML={{ __html: title }} />
						<p dangerouslySetInnerHTML={{ __html: description }} />
						<a href={link} target='_blank' rel='noreferrer' className='button button-primary' dangerouslySetInnerHTML={{ __html: linkText }} />
					</div>
				})}
			</div>

			<div className='video box'>
				<h2>Video Tutorials</h2>

				<div class='videoContainer'>
					<iframe width='100%' src='https://www.youtube.com/embed/7WujJwZyoFo' frameborder='0' allowfullscreen></iframe>
				</div>
			</div>
		</div>
	</div>, adminEl);
});